import { useEffect, useState } from 'react'
import type { TPersonMatch } from '@schemas'
import { subscribeToPersonAccessDenials } from '@/lib/apiClient'

/**
 * The contact review a Check-In host has open. Changing shows or losing People access clears the
 * pending selection and search; only lost access during an open review leaves an explanation.
 * A refused search keeps its text, because the results area reports that denial itself.
 */
export function usePendingPersonReview(
  showId: string | null | undefined,
  setSearchTerm: (term: string) => void
) {
  const [accessMessage, setAccessMessage] = useState('')
  const [reviewMatch, setReviewMatch] = useState<TPersonMatch | null>(null)
  const [editPersonId, setEditPersonId] = useState<string | null>(null)
  const reviewing = Boolean(reviewMatch || editPersonId)
  useEffect(() => {
    setReviewMatch(null)
    setEditPersonId(null)
    setSearchTerm('')
    setAccessMessage('')
  }, [showId, setSearchTerm])
  useEffect(
    () =>
      subscribeToPersonAccessDenials(lookup => {
        if (reviewing)
          setAccessMessage(
            'Contact review closed because your access changed. Sign in or check your show assignment before searching again.'
          )
        setReviewMatch(null)
        setEditPersonId(null)
        if (!lookup) setSearchTerm('')
      }),
    [reviewing, setSearchTerm]
  )
  useEffect(() => {
    if (reviewing) setAccessMessage('')
  }, [reviewing])
  return { accessMessage, reviewMatch, setReviewMatch, editPersonId, setEditPersonId }
}
